export default __webpack_public_path__ + "static/media/broken-link.13ec4528.svg";